import { render, staticRenderFns } from "./SharedViewTradie.vue?vue&type=template&id=8b8043da&scoped=true"
import script from "./SharedViewTradie.vue?vue&type=script&lang=js"
export * from "./SharedViewTradie.vue?vue&type=script&lang=js"
import style0 from "./SharedViewTradie.vue?vue&type=style&index=0&id=8b8043da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8043da",
  null
  
)

export default component.exports